import { SortingState } from "@tanstack/react-table";
import { DataTable } from "@/components/Base/Datatable";
import { TechnicianStats } from "@/types/v2/DispatchView";
import { useTableColumnVisibility } from "@/hooks/useTableColumnVisibility";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";
import { technicianHoursColumns } from "./TechnicianHoursTable.columns";
import { DISPATCH_TABLE_CLASSNAMES } from "./tableDensity";

const columns = technicianHoursColumns();

// Design-doc default: fewest Approved hours first (see column-sorting note
// in TechnicianHoursTable.columns.tsx for why `userDefaults.sorting`, not
// the controlled `sorting` prop, is used).
const DEFAULT_SORTING: SortingState = [{ id: "approvedHours", desc: false }];

export function TechnicianHoursTable({
  technicianStats,
  onSelectEmployee,
}: {
  technicianStats: TechnicianStats[];
  onSelectEmployee: (employeeId: string, employeeName: string) => void;
}) {
  const { initialColumnVisibility, persistColumnVisibility } =
    useTableColumnVisibility(
      LOCAL_STORAGE_BASE_KEYS.DISPATCH_TECHNICIAN_HOURS_COLUMNS
    );

  const selectRow = (stats: TechnicianStats) =>
    onSelectEmployee(stats.technicianId, stats.technicianName);

  return (
    <DataTable
      columns={columns}
      data={technicianStats}
      // `sorting` is spread in explicitly rather than reusing a stored
      // layout blob: only visibility is persisted, so the design-doc
      // default sort can never be dropped by a stale stored object.
      userDefaults={{
        sorting: DEFAULT_SORTING,
        columnVisibility: initialColumnVisibility,
      }}
      onColumnVisibilityChange={persistColumnVisibility}
      hidePagination
      containerClassName={DISPATCH_TABLE_CLASSNAMES.container}
      toolbarClassName={DISPATCH_TABLE_CLASSNAMES.toolbar}
      rowClassName="cursor-pointer focus:bg-muted/50"
      onRowClick={(stats) => selectRow(stats)}
      onRowKeyDown={(stats, event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          selectRow(stats);
        }
      }}
    />
  );
}
